/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import PropTypes from 'prop-types';
import React from 'react';
import { withRequests } from '../../../../higherOrderComponents/requests/';
import { withRouter } from 'react-router-dom';
import InstanceSubscribeModal from '../../../components/Modal/InstanceSubscribeModal';

class InstanceSubscribeModalContainer extends React.Component {
  static propTypes = {
    requests: PropTypes.object,
    instance: PropTypes.object,
    router: PropTypes.object
  }

  constructor(props) {
    super(props);
    this.close = this.close.bind(this);
  }

  // Route back to instance page
  close() {
    const aliasKey = this.props.match.params.aliasKey;
    const instanceKey = this.props.requests.instancePreview.value.key;
    const { location } = this.props.history;
    const newPathName = aliasKey ? '/alias/' + aliasKey
      : '/instances/' + instanceKey;
    this.props.history.replace({
      ...location,
      pathname: newPathName
    });
  }

  render() {
    const { requests } = this.props;
    const instanceKey = requests.instancePreview.value.key;

    return (
      <InstanceSubscribeModal
        isOpen={true}
        submit={this.close}
        closeModal={this.close}
        requests={requests}
        instanceKey={instanceKey}
      />
    );
  }
}

// mount with API routes and router props
export default withRouter(withRequests(InstanceSubscribeModalContainer));
